import React, { useRef, useEffect } from 'react';
import { startGame, stopBackgroundMusic } from './startGame';

const GameCanvas = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (canvasRef.current) {
      startGame(canvasRef.current);
    }
    return () => {
      stopBackgroundMusic();
    };
  }, []);

  return (
    <div className="game-canvas-wrapper">
      <canvas
        ref={canvasRef}
        width={1024}
        height={576}
        className="game-canvas"
        style={{
          display: 'block',
          margin: '2rem auto',
          width: '100%',
          maxWidth: '1024px',
          borderRadius: '12px',
          boxShadow: '0 0 12px rgba(0, 0, 0, 0.3)',
        }}
      />
    </div>
  );
};

export default GameCanvas;